/**
 * useSchoolVersion.js
 *
 * 校園版授權判斷 composable
 * 統一判斷是否擁有校園版授權，控制遊戲管理、SharingDB 推送、名單勾選、成績檢視等功能
 *
 * 授權來源：
 * - Init.GameHome 訊息 → authData.school_vers（由 HTwbActKitHome 寫入 sessionStorage）
 * - HiTeachCC.Auth 訊息 → iframe 環境自動 true
 * - sessionStorage('school_vers') → 頁面返回時恢復
 */

import { computed } from 'vue';

export const useSchoolVersion = () => {
    const schoolVers = computed(() => {
        return localStorage.getItem('school_vers') === 'true';
    });

    return { schoolVers };
};
